var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordpressColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t.st2{fill:#21759B;}\n\t\t.st3{fill:#FFFFFF;}\n\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WordPress Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32,
    cy: 32,
    r: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,11.9c4,0,7.9,1.2,11.2,3.4c2.1,1.5,4,3.3,5.4,5.4c4.6,6.8,4.6,15.6,0,22.4c-1.5,2.1-3.3,4-5.4,5.4 c-6.8,4.6-15.6,4.6-22.4,0c-2.1-1.5-4-3.3-5.4-5.4c-4.6-6.8-4.6-15.6,0-22.4c1.5-2.1,3.3-4,5.4-5.4C24.1,13.1,28,11.9,32,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.3,32c0,6.8,3.9,13,10,16l-8.5-23.3C14.7,27.1,14.3,29.5,14.3,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,31.1c0-1.7-0.5-3.5-1.5-4.9c-0.9-1.5-1.7-2.7-1.7-4.2c0-1.6,1.3-3.1,3-3.2H44c-7.3-6.6-18.5-6.1-25.1,1.2 c-0.7,0.7-1.3,1.5-1.7,2.2h1.2c1.8,0,4.8-0.2,4.8-0.2c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.7-0.6,0.7c0,0-1,0.1-2,0.2L27.7,43 l3.9-11.6l-2.7-7.6c-1,0-1.8-0.2-1.8-0.2c-0.4-0.1-0.7-0.5-0.6-0.9s0.4-0.6,0.7-0.6c0,0,2.9,0.2,4.7,0.2c1.7,0,4.8-0.2,4.8-0.2 c0.4,0,0.8,0.4,0.7,0.8c0,0.4-0.3,0.7-0.6,0.7c0,0-1,0.1-2,0.2L41,42.9l1.8-5.8C43.4,35.1,43.8,33.1,44,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.3,33.6L27,49.1c3.6,1.1,7.4,1,11-0.3c0-0.1-0.1-0.2-0.1-0.3L32.3,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,23.5c0.1,0.6,0.1,1.3,0.1,1.8c0,2.2-0.5,4.4-1.4,6.4l-5.4,15.7C49.3,42.5,52.2,31.9,47.6,23.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressColor);
export default __webpack_public_path__ + "static/media/wordpress-color.f510a36b71a4222ad1e8405e879e4cd5.svg";
export { ForwardRef as ReactComponent };